// extracted by mini-css-extract-plugin
export default {"title":"index_title__pKzny","headerText":"index_headerText__h86Ly","placeholder":"index_placeholder__iYThi","backButton":"index_backButton__W84ZU","backIcon":"index_backIcon__0Asm8"};